import React from 'react';
import {connect} from 'react-redux';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {evaluateOperator} from 'common/utils';
import contentMap from 'componentLibrary';
import {DynamicSubmitButton as _DynamicSubmitButton} from 'app-ui-componentlibrary/dist/componentLibrary/form/DynamicSubmitButton';
import _ from 'lodash';

export const DynamicSubmitButton = (props) => (
  <_DynamicSubmitButton {...{contentMap}} {...{evaluateOperator}} {...props} />
);
export const mapStateToProps = (state, props) => {
  const savingData =
    _.get(state, 'dynamicComponent.pendingSave') ||
    _.get(state, 'dynamicComponent.savingData');
  const roomListPath = 'dynamicComponent.collaboration.roomList';
  const roomsPath = 'dynamicComponent.collaboration.rooms';
  // Getting key CE info before we handle submission
  const currentlyCollaborating = !!_.get(state, roomListPath, '');
  const entitySubmitted = _.get(props, 'entityToSave.entityId');
  const isEntityLocked = _.get(
    state,
    `${roomsPath}.${entitySubmitted}.lockInfo.locked`,
    ''
  );
  const whoLockedEntity = _.get(
    state,
    `${roomsPath}.${entitySubmitted}.lockInfo.lockedBy`,
    ''
  );
  return {
    validationErrors: state.dynamicComponent.validationErrors,
    savingData,
    currentlyCollaborating,
    isEntityLocked,
    whoLockedEntity,
    entitySubmitted,
  };
};

export default connect(mapStateToProps)(connectDynamic(DynamicSubmitButton));
